import Homepage from "../../components/HomePageStij/Homepage";
import MadeOf from "../../components/WhatIsMadeOf";
import OwnProduction from "../../components/OwnPropduction/OwnProduction";
import States from "../../components/States/States";
import Development from "../../components/DevelopmentOfProduct/Development";
import SystemControlFlights from "../../components/SystemControlFlights/SystemControlFlights";
import ImplementFeatures from "../../components/ImplementationFeatures/ImplementationFeatures";
const ProjectStrij = () => {
    return(
        <>
            <Homepage/>
            <div className='flex flex-col gap-20 max-w-[1920px] py-20
            xl:px-[120px]
            lg:px-[60px] 
            md:px-12 
            sm:px-7 '>
                <MadeOf/>
                <OwnProduction/>
                <ImplementFeatures/>
                <SystemControlFlights/>
                <States/>
                <Development/>
            </div>
        </>
    )
}
export { ProjectStrij};